import React, { useState } from 'react'
import Table from '@toasttab/shared/src/components/organisms/MDS/Table/Table'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { FootnotesOptions } from '@toasttab/shared/src/utils/Contentful/richText'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import classNames from 'classnames'

interface ContentfulMdsPricingTableProps {
  __typename?: string
  contentful_id?: string
  eyebrow?: string
  title?: string
  showTableLabel?: string
  hideTableLabel: string
  table?: any
  footnotes?: any
  uniqueId?: string
  dataTestId?: string
}

const ContentfulMdsPricingTable = ({
  __typename,
  contentful_id,
  eyebrow,
  title,
  showTableLabel,
  hideTableLabel,
  table,
  footnotes,
  uniqueId,
  dataTestId = 'ContentfulMdsPricingTable-1'
}: ContentfulMdsPricingTableProps) => {
  const [tableHidden, setTableHidden] = useState(true)
  const toggleTableDisplay = () => {
    setTableHidden(!tableHidden)
  }
  let columns = 5
  const tableContainterClass = classNames({ hidden: tableHidden })
  if (table && table.rows.length > 0) {
    columns = table.rows[0].cells.length
  }
  let tableClasses = classNames({
    '[&_td:first-child]:w-[36%] [&_td:nth-child(2)]:w-[16%] [&_td:nth-child(3)]:w-[16%] [&_td:nth-child(4)]:w-[16%] [&_td:nth-child(5)]:w-[16%] sm:[&_td:first-child]:w-[26%] sm:[&_td:nth-child(2)]:w-[15%] sm:[&_td:nth-child(3)]:w-[15%] sm:[&_td:nth-child(4)]:w-[15%] sm:[&_td:nth-child(5)]:w-[29%]':
      columns === 5,
    '[&_td:first-child]:w-[34%] [&_td:nth-child(2)]:w-[22%] [&_td:nth-child(3)]:w-[22%] [&_td:nth-child(4)]:w-[22%] sm:[&_td:first-child]:w-[25%] sm:[&_td:nth-child(2)]:w-[25%] sm:[&_td:nth-child(3)]:w-[25%] sm:[&_td:nth-child(4)]:w-[25%]':
      columns === 4,
    '[&_td]:w-[33%]': columns === 3,
    '[&_td]:w-[50%]': columns === 2
  })

  return (
    <section id={uniqueId} data-testid={dataTestId}>
      <div className='ds-wrapper mt-[17px] mt-[56px]  sm:mt-10  sm:mb-8'>
        <div className='sm:ds-container'>
          {eyebrow && (
            <div className='w-full text-center mb-8 sm:mb-10'>
              <Typography as='h4' variation='h4' classes=''>
                {eyebrow}
              </Typography>
            </div>
          )}
          <span id='tt0'></span>
          <span id='tt1'></span>
          <span id='tt2'></span>
          <span id='tt3'></span>
          <span id='tt4'></span>
          {showTableLabel && (
            <div className='justify-self-center sm:w-full text-center mb-[56px] sm:mb-[34px]'>
              <Button
                variation='secondary'
                onClick={() => toggleTableDisplay()}
                classes='!font-semibold !w-auto'
                fullwidth={false}
              >
                {tableHidden && <>+&nbsp;&nbsp;{showTableLabel}</>}
                {!tableHidden && <>-&nbsp;&nbsp;{hideTableLabel}</>}
              </Button>
            </div>
          )}
          <div className={tableContainterClass} id='pricingTableContainter'>
            {title && (
              <div className='w-full text-left sm:text-center mb-20 sm:mb-6 ml-4 sm:ml-0'>
                <Typography as='h2' variation='h2'>
                  {title}
                </Typography>
              </div>
            )}
            <Table
              table={table}
              columns={columns}
              onVisibityUpdate={toggleTableDisplay}
              tableClasses={tableClasses}
            />
            {footnotes && (
              <div className='border-b border-b-gray-30 sm:border-b-0 mx-4 sm:mx-0 sm:mt-[76px] pt-10 pb-8 sm:border-t sm:border-t-default'>
                {renderRichText(footnotes, FootnotesOptions)}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContentfulMdsPricingTable
